import { merge, cloneDeep, find } from 'lodash';

export default {
  SET_QUESTION_LIST: (state, data) => {
    state.roomQuestionList = cloneDeep(data);
  },

  SET_QUESTION: (state, questionData) => {
    const question = questionData.roomQuestion
    const questionId = question.questionId
    const questionStatusType = questionData.statusType
    const questionStatusTypeUppercase = questionStatusType.replace(/\b[a-z]/, letter => letter.toUpperCase())
    const questionStatus = questionData.value

    let roomQuestion = find(state.roomQuestionList, { questionId })

    merge(roomQuestion, {
      [`is${questionStatusTypeUppercase}`]: questionStatus
    })

    if(questionStatusType == 'share') {
      state.currentQuestion = cloneDeep(question)
      state.isModalQuestion = questionStatus
    }
  },

  // 질문 리스트 조회
  SET_QUESTION_INFO: (state, data) => {
    const questionInfo = data?.questionInfo;
    const questionList = data?.questionList;

    if (!questionInfo && !questionList) {
      return;
    }

    if (questionInfo.isOpen === null) {
      questionInfo.isOpen = false;
    }

    if (questionList?.length) {
      state.roomQuestionList = cloneDeep(questionList);
    }
    state.questionOpenStatus = questionInfo.isOpen;
  },

  SET_QUESTION_ALERT: (state, newState = true) => {
    state.isNewQuestion = newState
  },

  DELETE_QUESTION: (state, questionId) => {
    state.roomQuestionList = state.roomQuestionList.filter(question => question.questionId !== questionId)
  },

  // 댓글 등록
  SET_QUESTION_COMMENT: (state, data) => {
    state.roomQuestionList = state.roomQuestionList.map(question => {
      if (question.questionId === data.questionId) {
        question.comments.push(data);
      }

      return question;
    });
  },

  // 댓글 삭제
  DELETE_QUESTION_COMMENT: (state, data) => {
    state.roomQuestionList = state.roomQuestionList.map(question => {
      if (question.questionId === data.questionId) {
        question.comments = question.comments.filter(comment => comment.commentId !== data.commentId);
      }

      return question;
    });
  },

  // 질문 좋아요
  SET_QUESTION_LIKE: (state, data) => {
    state.roomQuestionList = state.roomQuestionList.map(question => {
      if (question.questionId !== data.questionId) return question;

      if (question.likes.some(like => like.userId === data.userId)) {
        const idx = question.likes.findIndex(like => like.userId === data.userId);
        question.likes.splice(idx, 1);
      } else {
        question.likes.push(data);
      }

      return question;
    });
  },

  // 질문 좋아요
  DELETE_QUESTION_LIKE: (state, { likeId, questionId }) => {
    state.roomQuestionList = state.roomQuestionList.map(question => {
      if (question.questionId !== questionId) return question;

      question.likes = question.likes.filter(like => like.likeId !== likeId);

      return question;
    });
  },
};
